import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const scrollToSection = (sectionId) => {
    // Navigate to home page and scroll to section
    window.location.href = `/#${sectionId}`;
  };

  return (
    <footer>
      <div className="footer-container">
        {/* Kontaktinformationen */}
        <div>
          <h4>Kontakt</h4>
          <p>
            FH Consulting<br />
            Bauernfeindstr. 8<br />
            80939 München
          </p>
          <p>
            Telefon: <a href="tel:+4915292608956">+49 1529 2608956</a><br />
            E‑Mail: <a href="mailto:info@fh-consulting.de">info@fh-consulting.de</a>
          </p>
        </div>
        
        {/* Schnellzugriff */}
        <div>
          <h4>Schnellzugriff</h4>
          <ul>
            <li>
              <button 
                onClick={() => scrollToSection('home')}
                className="footer-link-button"
              >
                Startseite
              </button>
            </li>
            <li>
              <button 
                onClick={() => scrollToSection('about')}
                className="footer-link-button"
              >
                Unser&nbsp;Warum
              </button>
            </li>
            <li>
              <button 
                onClick={() => scrollToSection('services')}
                className="footer-link-button"
              >
                Leistungen
              </button>
            </li>
            <li>
              <Link to="/contact">Kontakt</Link>
            </li>
          </ul>
        </div>
        
        {/* Rechtliches */}
        <div>
          <h4>Rechtliches</h4>
          <ul>
            <li>
              <Link to="/impressum">Impressum</Link>
            </li>
            <li>
              <Link to="/datenschutz">Datenschutz</Link>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        © 2025 FH Consulting – Alle Rechte vorbehalten.
      </div>
    </footer>
  );
}

export default Footer;
